var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"color":"#363636","tile":"","flat":""}},[_c('v-card-title',[_vm._v(" Daily User Logins ")]),_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{attrs:{"id":"login-graph"}})])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }